export const config = {
  title: "Debbie Duncan | Selling Southern Illinois Realty",
  meta: {
    description:
      "Debbie Duncan at Selling Southern Illinois Realty helps you find your perfect home in Goreville, IL and surrounding areas with professional real estate expertise.",
    keywords: [
      "Debbie Duncan",
      "Selling Southern Illinois Realty",
      "Homes in Goreville IL",
      "Southern Illinois real estate",
      "Real estate agent Goreville IL",
      "Buy home Goreville",
    ],
    author: "Debbie Duncan | Selling Southern Illinois Realty",
    canonicalUrl: "https://www.dealinghomeswithdebbie.com/",
  },
  sections: {
    header: {
      businessName: "Debbie Duncan | Selling Southern Illinois Realty",
    },
    sectionB: {
      heroTitle: "Find Your Dream Home in Southern Illinois",
      heroSubtitle: "Professional real estate guidance from Debbie Duncan",
      learnAboutText: "Browse Listings",
      phoneNumber: "6182183842",
      phoneLabel: "(618) 218-3842",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2164822692/photo/suburban-sprawl.jpg?s=612x612&w=0&k=20&c=Z1eiTgQPjSVSpTwcNr7gcvIcBX8lMjCHeV_iDxqWONA=",
      cardData: [
        {
          title: "Local Expertise",
          description:
            "Serving Goreville and surrounding counties with in-depth market knowledge.",
        },
        {
          title: "Personalized Guidance",
          description:
            "Helping clients every step of the way—from listing to closing.",
        },
        {
          title: "Responsive Communication",
          description:
            "Clear and timely updates to ensure a smooth home buying or selling process.",
        },
      ],
      description:
        "Whether you're buying or selling a home, Debbie Duncan with Selling Southern Illinois Realty is committed to helping you succeed in today’s real estate market.",
    },
    sectionC: {
      servicesTitle: "My Services",
      servicesDescription:
        "Offering comprehensive support for home buyers and sellers throughout Southern Illinois.",
      cards: [
        {
          title: "Residential Listings",
          description:
            "Search and list single-family homes, condos, and land for sale.",
          imageSrc: "https://media.istockphoto.com/id/2222408945/photo/american-neighborhood-houses-with-for-sale-graphic-signs-above-homes-aerial-view-at-sunset-of.jpg?s=612x612&w=0&k=20&c=lVJkHN7tloOVJjitr9UPdDlN9rwL0Z0-4TozZMZzfxw=",
          imageAlt: "Residential Real Estate",
        },
        {
          title: "Buyer Representation",
          description:
            "Find and negotiate the right home for your needs and budget.",
          imageSrc: "https://media.istockphoto.com/id/2166772260/photo/real-estate-virtual-tour-mobile-photo-camera-app.jpg?s=612x612&w=0&k=20&c=T3QU4RcRDYZA-BC1sm6DROTUQo4APXXTjOc6Dexr8mc=",
          imageAlt: "Buyer Agent Support",
        },
        {
          title: "Seller Assistance",
          description:
            "Professional listing services, pricing strategy, and marketing support.",
          imageSrc: "https://media.istockphoto.com/id/1156574440/photo/lawyer-insurance-broker-consulting-giving-legal-advice-to-couple-customer-about-buying.jpg?s=612x612&w=0&k=20&c=FhHmEuX_4q1TNF5eDTL5-CoxjQwjflz8mk0UO6oHmcI=",
          imageAlt: "Seller Real Estate Services",
        },
      ],
      otherServicesTitle: "Specialties",
      otherServicesList: [
        "Home Valuation",
        "Real Estate Consultations",
        "Land Sales",
        "Local Market Reports",
      ],
    },
    sectionD: {
      aboutTitle: "About Debbie",
      aboutImage: {
        src: "https://images.marketleader.com/MarketingImages/19/2405519_normal.PNG",
        alt: "Debbie Duncan Real Estate",
      },
      aboutText: [
        "Debbie Duncan is a dedicated real estate professional with Selling Southern Illinois Realty, offering exceptional service and market knowledge.",
        "She prides herself on helping clients through the buying and selling journey with honesty, integrity, and care.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Debbie Duncan Logo",
      businessName: "Debbie Duncan | Selling Southern Illinois Realty",
      contact: {
        phone: "6182183842",
        phoneLabel: "(618) 218-3842",
        email: "debbie.sellingsirealty@gmail.com",
        website: "https://www.dealinghomeswithdebbie.com/",
        address: "400 S Broadway, Goreville, IL 62939",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "400 S Broadway, Goreville, IL 62939",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3135.348167676345!2d-89.0188157!3d37.555289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8876025d5cf6efcf%3A0xd45f9d1b276a2353!2s400%20S%20Broadway%20St%2C%20Goreville%2C%20IL%2062939%2C%20USA!5e0!3m2!1sen!2sus!4v1720000000000!5m2!1sen!2sus",
    },
  },
};

export default config;
